export default class StorageKeys {
    public static readonly Token: string = 'cargoxs-airside-token';
}